exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-tooltip.cap-tooltip-overlay-v2{max-width:324px}.ant-tooltip.cap-tooltip-overlay-v2 .ant-tooltip-inner{background-color:#091e42;font-size:14px;font-weight:500}.ant-tooltip.cap-tooltip-overlay-v2.cap-bgcolor-tooltip .ant-tooltip-inner{background-color:#2466ea}.ant-tooltip.cap-tooltip-overlay-v2.hide-tooltip-pointer .ant-tooltip-arrow{display:none}.button-disabled-tooltip-wrapper{display:inline-flex;cursor:not-allowed}.button-disabled-tooltip-wrapper .cap-button-v2.ant-btn[disabled]{pointer-events:none}.button-disabled-tooltip-wrapper .cap-button-v2.ant-btn[disabled]>*{pointer-events:auto;cursor:not-allowed}\n", ""]);

// exports
